import { createQueryKeys } from "@lukemorales/query-key-factory";

import { createServiceResponseSchema, privateApi } from "@/api/axios";
import { messagesDataModelSchema } from "@/domains/messages/models/schemas";

export const messagesQueryOptions = createQueryKeys("messages", {
  all: {
    queryKey: null,
    queryFn: () => {
      return getMessages();
    },
  },
});

export const getMessages = async () => {
  const response = await privateApi.get("/messages");

  return createServiceResponseSchema(messagesDataModelSchema).parse(response.data).data;
};
